var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    {
      staticStyle: {
        padding: "40px 16px 40px 16px",
        "background-color": "#2D2D2D"
      }
    },
    [
      _c("el-col", { attrs: { span: 24 } }, [
        _c("span", { staticClass: "social-font" }, [
          _vm._v("#"),
          _c("b", [_vm._v("UNIFI")]),
          _vm._v("Property")
        ])
      ]),
      _vm._v(" "),
      _c("el-col", { staticClass: "flex-centered", attrs: { span: 24 } }, [
        _c("img", {
          staticStyle: { width: "343px", height: "250px" },
          attrs: {
            loading: "lazy",
            src: require("../../assets/social-image.jpg")
          }
        })
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-fe796562", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fe796562","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/package/socialSection.vue
// module id = null
// module chunks = 